import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

type Props = {
  children: string,
  link?: string,
}

const Copyright = (props: Props) => {
    const { link, children } = props;

    return (
        <CopyrightWithStyled className="text-center" { ...props }>
            <Link className="text-dark" to={ link || '/react' }>
                <CopyrightTextWithStyled translate="no">{ children }</CopyrightTextWithStyled>
            </Link>
        </CopyrightWithStyled>
    );
};

const CopyrightWithStyled = styled.div`
`
const CopyrightTextWithStyled = styled.small`
    font-size: 12px;
`

export default Copyright;